import { useRef } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';

import { useOnMountEffect } from '~shared/hooks/use-on-mount-effect';

function isTransactionsRoute(route: string) {
  return route === '/transactions';
}

const TAB_KEY = 'lastTransactionsTab';
const DEFAULT_TAB = 'loans';

export function useLastVisitedTab() {
  const lastTabRef = useRef<string>();
  const location = useLocation();
  const navigate = useNavigate();
  const currentTabMatch = useMatch('/transactions/:tab');

  const shouldRedirect = isTransactionsRoute(location.pathname);

  /**
   * initialize tab with local storage value
   * or set default value for the first visit
   */
  if (!lastTabRef.current) {
    const savedLastTab = localStorage.getItem(TAB_KEY);
    lastTabRef.current = savedLastTab || DEFAULT_TAB;
  }

  /**
   * we should redirect to the right tab from "/transactions" page
   */
  useOnMountEffect(() => {
    if (shouldRedirect) {
      navigate(lastTabRef.current ?? DEFAULT_TAB, { replace: true });
    }
  });

  /**
   * we should track and save to localStorage last visited tab
   */
  if (
    !shouldRedirect &&
    currentTabMatch?.params.tab &&
    currentTabMatch.params.tab !== lastTabRef.current
  ) {
    lastTabRef.current = currentTabMatch.params.tab;
    localStorage.setItem(TAB_KEY, lastTabRef.current);
  }
}
